export default __webpack_public_path__ + "static/media/ringer.3a5963d9.wav";